module.exports = __webpack_public_path__ + "img/banner3.c3df4e75.png";